import { modules } from "@core/utils/modules.js";

export default [
    {
        path: "attendance",
        name: "bookeeping-attendance",
        redirect: { name: "bookeeping-attendance-report" },
        component: () => import("@/views/bookeeping/views/bookeeping-attendance/BookeepingAttendanceMain.vue"),
        meta: {
            section: 41,
            module: modules.BOOKEEPING

        },
        children: [
            {
                path: "report",
                name: "bookeeping-attendance-report",
                component: () =>
                    import(
              /* webpackChunkName: "BookeepingAttendanceReportTable" */ "@/views/commons/employee_attendance/AttendanceReportTable.vue"
                    ),
                meta: {
                    section: 41,
                    pageTitle: "Attendance",
                    module: modules.BOOKEEPING
                },
            },

        ],
    },
];